import { ProductInterface, Maybe } from '@pylot-data/fwrdschema'
import { translateRatingToDecimal } from '@lib/utils/translateRatingToDecimal'

type ReviewData = {
    '@type'?: 'Review'
    author?: {
        '@type'?: 'Person'
        name?: string
    }
    datePublished?: Maybe<string>
    name?: Maybe<string>
    reviewBody?: Maybe<string>
    reviewRating?: {
        '@type'?: 'Rating'
        ratingValue?: Maybe<number>
        bestRating?: number
        worstRating?: number
    }
}

const getDatePublished = (date: string): string => {
    let formattedDate = ''
    if (date && date !== '' && date.length > 15)
        formattedDate = `${date
            .substring(5, 10)
            .replace('-', '/')}/${date.substring(0, 4)}`
    return formattedDate
}

export const getReviews = (
    product: ProductInterface
): Record<string, unknown> => {
    const reviewsToSchema: Maybe<Array<ReviewData>> = []

    if (product?.reviews?.items) {
        product.reviews.items.forEach((review) => {
            if (!review) return

            const reviewData: ReviewData = {
                '@type': 'Review',
                author: {
                    '@type': 'Person',
                    name: review.nickname
                },
                datePublished: getDatePublished(review.created_at),
                name: review.summary,
                reviewBody: review.text,
                reviewRating: {
                    '@type': 'Rating',
                    ratingValue: parseInt(
                        translateRatingToDecimal(review.average_rating)
                    ),
                    bestRating: 5,
                    worstRating: 1
                }
            }
            reviewsToSchema.push(reviewData)
        })
    }

    if (reviewsToSchema.length === 0) {
        return {}
    }

    return {
        review: reviewsToSchema
    }
}
